import React, { useEffect } from 'react';
import HeroSection from '../components/Home/HeroSection';
import AIIntelligenceSection from '../components/Home/AIIntelligenceSection';
import MidPageCTA from '../components/Home/MidPageCTA';
import PricingVisibilityBar from '../components/Home/PricingVisibilityBar';
import OutcomesSection from '../components/Home/OutcomesSection';
import PlatformInfographic from '../components/Home/PlatformInfographic';
import ModuleGrid from '../components/Home/ModuleGrid';
import SocialProofSection from '../components/Home/SocialProofSection';
import PricingSection from '../components/Home/PricingSection';
import EnhancedFAQSection from '../components/Home/EnhancedFAQSection';
import ProductAssistantWidget from '../components/Home/ProductAssistantWidget';
import StickyCTAFooter from '../components/Home/StickyCTAFooter';
import { updateMetaTags, addStructuredData } from '../utils/seo';

const Home: React.FC = () => {
  useEffect(() => {
    // Update meta tags for the home page
    updateMetaTags({
      title: 'Explanatum | Complete AI Business Platform - From Idea to Revenue',
      description: '23 AI-powered business modules in one platform. £19/user/month or £49/month for teams (3 users). Replace 10+ subscriptions with our complete suite for strategy, marketing, sales, CRM, project management, HR, and finance.',
      ogTitle: 'Explanatum | Your Complete AI Business Platform',
      ogDescription: '23 AI modules: £19/user or £49 for 3 users. All-in-one platform for strategy, marketing, sales, finance, operations, and project management. Stop juggling subscriptions—get everything in one place.',
      ogUrl: typeof window !== 'undefined' ? window.location.href : 'https://explanatum.co.uk/',
      twitterUrl: typeof window !== 'undefined' ? window.location.href : 'https://explanatum.co.uk/',
      ogImage: 'https://explanatum.co.uk/images/Explanatum.png',
      canonicalUrl: 'https://explanatum.co.uk/'
    });
    
    // Add structured data for rich snippets
    addStructuredData({
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      'name': 'Explanatum',
      'applicationCategory': 'BusinessApplication',
      'description': 'Complete AI business platform with 23 modules and 40+ tools for strategy, marketing, sales, finance, operations, HR, and project management.',
      'offers': [
        {
          '@type': 'Offer',
          'name': 'Single User',
          'price': '19',
          'priceCurrency': 'GBP',
          'availability': 'https://schema.org/InStock'
        },
        {
          '@type': 'Offer',
          'name': 'Team (3 Users)',
          'price': '49',
          'priceCurrency': 'GBP',
          'availability': 'https://schema.org/InStock'
        }
      ],
      'aggregateRating': {
        '@type': 'AggregateRating',
        'ratingValue': '4.8',
        'ratingCount': '127'
      }
    }, 'home-structured-data');
  }, []);

  return (
    <>
      {/* Phase 1: Hook & Build Trust */}
      <HeroSection />
      <PricingVisibilityBar />
      <OutcomesSection />
      <SocialProofSection />
      
      {/* Phase 2: Explain & Demonstrate */}
      <AIIntelligenceSection />
      <PlatformInfographic />
      <ModuleGrid />
      
      {/* Phase 3: Convert */}
      <MidPageCTA />
      <PricingSection />
      <EnhancedFAQSection />
      
      {/* Support & Persistent CTA */}
      <ProductAssistantWidget />
      <StickyCTAFooter />
    </>
  );
};

export default Home;
